import { BLOCKCHAIN_NAME } from 'src/core/blockchain/models/blockchain-name';

export const piteasOnChainSupportedBlockchains = [BLOCKCHAIN_NAME.PULSECHAIN] as const;
